// expects an dictionary of events grouped by month (string) at property.events
export default function getSumOfEventsForPropertiesInMonth(properties, month) {
  return reducer => {
    return properties.reduce((sum, property) => {
      return sum + reducer(property.events[month]);
    }, 0);
  };
}
